"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_DRAWER_OPEN = exports.SET_TABS = exports.SET_SELECTED_TAB = void 0;
//tabs
var SET_SELECTED_TAB = "SET_SELECTED_TAB";
exports.SET_SELECTED_TAB = SET_SELECTED_TAB;
var SET_TABS = "SET_TABS";
exports.SET_TABS = SET_TABS;
var SET_DRAWER_OPEN = "SET_DRAWER_OPEN";
exports.SET_DRAWER_OPEN = SET_DRAWER_OPEN;